import { useEffect } from 'react';
import companyStore from '../stores/CompanyStore';
import { normalizeContext } from '../util/contextUtils';

const useCompanyProfileById = ({ id, userContext }) => {
  useEffect(() => {
    companyStore.getCompany({
      id: +id,
      userContext: normalizeContext(userContext),
    });
    companyStore.getCompanyFeed({
      id: +id,
      userContext: normalizeContext(userContext),
    });
    companyStore.getCompanyMembers({
      id: +id,
      userContext: normalizeContext(userContext),
    });
    companyStore.getCompanyEvents({ id: +id });
  }, [id, userContext]);
};

export default useCompanyProfileById;
